


















import ApiSearch from "@/components/apiSearch/components/ApiSearch.vue";

import Vue from "vue";
import BankOutViewDTO from "../models/BankOutViewDTO";
import { FilteringModel } from "@/services/filtering";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  components: { ApiSearch },

  props: {
    extraFilter: { type: Object as () => FilteringModel },
  },

  data: () => ({
    filter: new FilteringModel(),
  }),

  beforeMount() {
    this.filter = new FilteringModel();
    if (this.extraFilter) this.filter = this.filter.fromFilter(this.extraFilter.toObject());
  },

  methods: {
    selected(item: BankOutViewDTO) {
      this.$emit("selected", item);
    },
  },

  computed: {
    columns: (): ApiSearchColumn[] => [
      { field: "prefix", title: t("Prefix") },
      { field: "invoiceID", title: t("Szamlaszam") },
      { field: "invoiceNo", title: t("KulsoSzamlaszam") },
      { cell: "total", field: "total", title: t("Osszeg"), type: ColumnType.Money },
      { field: "currency", title: t("Penznem") },
      { field: "partner", title: t("Partner") },
      { field: "status", title: t("Allapot"), type: ColumnType.Center },
      { field: "remark", title: t("Megjegyzes") },
    ],
  },
});
